import React from 'react';
import { Link } from 'react-router-dom';

import { EmptyContainer } from 'shared-components/EmptyContainer';
import { OutlineButton } from 'shared-components/Buttons/Outline';

const Empty = ({ description, buttonText, to, hideAction = false }) => (
  <EmptyContainer
    inline
    title='No data yet'
    description={!hideAction && description}
    renderCta={
      <Link
        to={to}>
        <OutlineButton
          width='100%'
          fontFamily='Montserrat'
          color='primary.blue1'
          borderColor='primary.blue1'
          text={buttonText}
        />
      </Link>
    }
    hideCta={hideAction}
  />
);

export default Empty;
